import React from "react"
import Toast from "react-bootstrap/Toast"
import ToastBody from "react-bootstrap/ToastBody"
import ToastHeader from "react-bootstrap/ToastHeader"
import store from "redux/store"
import { eraseToast } from "redux/ducks/Toast"

type ToastType = {
  show: boolean
  headerMessage?: string
  bodyMessage?: string
}

export const ToastMessage: React.FC<ToastType> = props => {
  return (
    <div className="toast-wrap">
      <div className="toast-contents">
        <Toast
          show={props.show}
          onClose={() => {
            store.dispatch(eraseToast())
          }}
          delay={3000}
          autohide
        >
          {props.headerMessage && (
            <ToastHeader>{props.headerMessage}</ToastHeader>
          )}
          <ToastBody>{props.bodyMessage}</ToastBody>
        </Toast>
      </div>
    </div>
  )
}
